var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-centerx"},[_c('div',[_c('m-pages-text',{attrs:{"item":_vm.item.heading,"text-size":"h2"}})],1),_c('div',[_c('m-pages-text',{attrs:{"item":_vm.item.subheading,"text-size":"subtitle-1"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }